// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1qEtA","fileBtn":"File_fileBtn__1hvgP","closeBtn":"File_closeBtn__1XnLf","fileSelected":"File_fileSelected__1m0Fy","disabled":"File_disabled__2dvLE"};